import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';

export const createPrivate = (member: string) => {
  return Http.request<string>({
    method: 'POST',
    url: `${API_CHAT_URL}/pairing/create-private`,
    body: {
      member,
    },
  });
};
